const logger = {
    log: (...args: any[]) => {
        console.log(...args);
}
};

export default logger;